export default "__VITE_ASSET__CYWWTNKj__"